import { useTranslation } from "react-i18next";
import type { CreativeContextSelection } from "@digital-twins/shared-types";
import { Text } from "@/components/ui/Text";
import { useCreativeLibrary } from "@/hooks/useCreativeLibrary";

/** A chat started from "Create with" says what it starts with, until the first message. */
export function CreativePresetLine(props: {
  selection?: CreativeContextSelection | null;
  className?: string;
}) {
  const { selection, className } = props;

  const { t } = useTranslation("app");
  const hasPreset = Boolean(
    selection?.brandProfileToken ||
    selection?.subjectToken ||
    selection?.productToken ||
    selection?.boardToken,
  );
  const library = useCreativeLibrary(hasPreset);
  const names = [
    library.brands.find((item) => item.token === selection?.brandProfileToken)?.name,
    library.subjects.find((item) => item.token === selection?.subjectToken)?.name,
    library.products.find((item) => item.token === selection?.productToken)?.name,
    library.boards.find((item) => item.token === selection?.boardToken)?.name,
  ].filter(Boolean);
  if (!hasPreset || names.length === 0) return null;
  return (
    <Text
      size="xs"
      color="muted"
      className={`truncate px-1 ${className ?? ""}`}
      data-testid="thread-creative-preset"
    >
      {t("creativeLibrary.usingPreset", { names: names.join(" · ") })}
    </Text>
  );
}
